import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class Reseller {
  private readonly http = inject(HttpClient);

  getResellers(filters: any = {}): Observable<any> {
    return this.http.get<any>(`${environment.apiPrefix}${environment.user.userList}`, {
      params: filters
    });
  }

  getPackages(filters: any = {}): Observable<any> {
    return this.http.get<any>(`${environment.apiPrefix}${environment.package.packageList}`, {
      params: filters
    });
  }

  addReseller(data: any): Observable<any> {
    return this.http.post<any>(`${environment.apiPrefix}${environment.user.user}`, data);
  }

  updateReseller(userId: string, data: any): Observable<any> {
    return this.http.put<any>(`${environment.apiPrefix}${environment.user.user}/${userId}`, data);
  }

  deleteReseller(userId: string): Observable<any> {
    return this.http.delete<any>(`${environment.apiPrefix}${environment.user.user}/${userId}`);
  }
}
